export const translations = {
  ro: {
    nav: {
      cars: "Masini",
      contact: "Contact",
      admin: "Admin",
      owner: "Proprietar",
      login: "Autentificare",
      logout: "Iesire",
    },
    common: {
      from: "De la",
      perDay: "/ zi",
      details: "Detalii",
      bookNow: "Rezerva acum",
      loading: "Se incarca...",
      cancel: "Anuleaza",
      save: "Salveaza",
      delete: "Sterge",
      edit: "Editeaza",
      back: "Inapoi",
      confirm: "Confirma",
      yes: "Da",
      no: "Nu",
      brand: "Marca",
      model: "Model",
      year: "An",
      transmission: "Transmisie",
      fuel: "Combustibil",
      seats: "Locuri",
      price: "Pret",
      features: "Dotari",
      description: "Descriere",
      automatic: "Automata",
      manual: "Manuala",
      petrol: "Benzina",
      diesel: "Diesel",
      hybrid: "Hibrid",
      electric: "Electric",
      currency: "Valuta",
      language: "Limba",
      all: "Toate",
      filter: "Filtreaza",
      reset: "Reseteaza",
      noResults: "Nu am gasit masini",
      add: "Adauga",
      close: "Inchide",
      pending: "In asteptare",
      approved: "Aprobata",
      rejected: "Respinsa",
      status: "Status",
      actions: "Actiuni",
      approve: "Aproba",
      reject: "Respinge",
    },
    hero: {
      title: "Eleganta in miscare",
      subtitle: "Inchiriaza masini premium in Pascani. Experienta exclusivista, servicii impecabile.",
      cta: "Exploreaza colectia",
    },
    home: {
      fleet: "Colectia noastra",
      filtersTitle: "Gaseste masina perfecta",
      allBrands: "Toate marcile",
      allTransmissions: "Toate transmisiile",
      priceRange: "Interval pret (EUR/zi)",
      testimonialsTitle: "Ce spun clientii nostri",
      testimonialsEyebrow: "Recenzii verificate",
      noReviewsYet: "Inca nu avem recenzii publice. Fii primul!",
      viewAllReviews: "Vezi toate recenziile",
      faqEyebrow: "Intrebari frecvente",
      faqTitle: "Tot ce trebuie sa stii",
      averageRating: "Rating mediu",
      totalReviews: "recenzii",
      quoteEyebrow: "Rapid si gratuit",
      quoteTitle: "Cere o oferta personalizata",
      quoteSubtitle: "Spune-ne ce iti trebuie si revenim cu cea mai buna varianta in cel mai scurt timp.",
      quoteName: "Numele tau",
      quotePhone: "Telefon",
      quoteEmail: "Email (optional)",
      quotePickup: "Data preluare",
      quoteReturn: "Data returnare",
      quoteCarPref: "Masina sau categorie preferata (optional)",
      quoteMessage: "Detalii suplimentare (optional)",
      quoteSubmit: "Trimite cererea",
      quoteSubmitting: "Se trimite...",
      quoteSuccess: "Multumim! Te contactam in cel mai scurt timp.",
      quoteError: "A aparut o eroare. Te rugam sa incerci din nou.",
    },
    car: {
      gallery: "Galerie",
      specs: "Specificatii",
      selectDates: "Selecteaza perioada",
      pickupDate: "Data preluare",
      returnDate: "Data returnare",
      pickDates: "Alege datele",
      reserveTitle: "Solicita rezervare",
      yourName: "Numele tau",
      yourEmail: "Email",
      yourPhone: "Telefon",
      message: "Mesaj (optional)",
      submit: "Trimite cererea",
      total: "Total estimat",
      submitting: "Se trimite...",
      successTitle: "Cererea a fost trimisa!",
      successBody: "Iti vom raspunde in scurt timp dupa ce administratorul confirma disponibilitatea.",
      conflict: "Perioada selectata nu este disponibila. Alege alte date.",
      requestSent: "Cerere trimisa",
    },
    login: {
      title: "Autentificare",
      subtitle: "Acces administratori si proprietari",
      email: "Email",
      password: "Parola",
      submit: "Intra in cont",
    },
    admin: {
      dashboard: "Panou admin",
      cars: "Masini",
      owners: "Proprietari",
      reservations: "Rezervari",
      settings: "Setari",
      addCar: "Adauga masina",
      addOwner: "Adauga proprietar",
      noOwner: "Fara proprietar",
      assignOwner: "Atribuie proprietar",
      uploadImages: "Incarca imagini",
      brandSection: "Brand si culori",
      smtpSection: "Configurare SMTP",
      emailTemplatesSection: "Sabloane email",
      logoUpload: "Logo",
      uploadLogo: "Incarca logo",
      removeLogo: "Sterge logo",
      colors: "Paleta culori",
      contactSection: "Contact",
      testEmail: "Trimite email test",
    },
    owner: {
      dashboard: "Panou proprietar",
      myCars: "Masinile mele",
      reservations: "Rezervari",
      blockDates: "Blocheaza date",
      addBlock: "Adauga blocaj",
      blockReason: "Motiv (optional)",
      noCars: "Nu ai masini atribuite",
    },
  },
  en: {
    nav: {
      cars: "Cars",
      contact: "Contact",
      admin: "Admin",
      owner: "Owner",
      login: "Sign in",
      logout: "Sign out",
    },
    common: {
      from: "From",
      perDay: "/ day",
      details: "Details",
      bookNow: "Book now",
      loading: "Loading...",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      brand: "Brand",
      model: "Model",
      year: "Year",
      transmission: "Transmission",
      fuel: "Fuel",
      seats: "Seats",
      price: "Price",
      features: "Features",
      description: "Description",
      automatic: "Automatic",
      manual: "Manual",
      petrol: "Petrol",
      diesel: "Diesel",
      hybrid: "Hybrid",
      electric: "Electric",
      currency: "Currency",
      language: "Language",
      all: "All",
      filter: "Filter",
      reset: "Reset",
      noResults: "No cars found",
      add: "Add",
      close: "Close",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      status: "Status",
      actions: "Actions",
      approve: "Approve",
      reject: "Reject",
    },
    hero: {
      title: "Elegance in motion",
      subtitle: "Rent premium cars in Pascani. An exclusive experience, impeccable service.",
      cta: "Explore the fleet",
    },
    home: {
      fleet: "Our collection",
      filtersTitle: "Find the perfect car",
      allBrands: "All brands",
      allTransmissions: "All transmissions",
      priceRange: "Price range (EUR/day)",
      testimonialsTitle: "What our clients say",
      testimonialsEyebrow: "Verified reviews",
      noReviewsYet: "No public reviews yet. Be the first!",
      viewAllReviews: "See all reviews",
      faqEyebrow: "Frequently asked",
      faqTitle: "Everything you need to know",
      averageRating: "Average rating",
      totalReviews: "reviews",
      quoteEyebrow: "Quick & free",
      quoteTitle: "Request a personalised quote",
      quoteSubtitle: "Tell us what you need and we'll get back to you with the best option shortly.",
      quoteName: "Your name",
      quotePhone: "Phone",
      quoteEmail: "Email (optional)",
      quotePickup: "Pickup date",
      quoteReturn: "Return date",
      quoteCarPref: "Preferred car or category (optional)",
      quoteMessage: "Additional details (optional)",
      quoteSubmit: "Send request",
      quoteSubmitting: "Sending...",
      quoteSuccess: "Thank you! We'll contact you shortly.",
      quoteError: "Something went wrong. Please try again.",
    },
    car: {
      gallery: "Gallery",
      specs: "Specifications",
      selectDates: "Select dates",
      pickupDate: "Pickup date",
      returnDate: "Return date",
      pickDates: "Pick dates",
      reserveTitle: "Request reservation",
      yourName: "Your name",
      yourEmail: "Email",
      yourPhone: "Phone",
      message: "Message (optional)",
      submit: "Submit request",
      total: "Estimated total",
      submitting: "Submitting...",
      successTitle: "Request sent!",
      successBody: "We will get back to you shortly after the administrator confirms availability.",
      conflict: "Selected period is not available. Please pick other dates.",
      requestSent: "Request sent",
    },
    login: {
      title: "Sign in",
      subtitle: "Administrator and owner access",
      email: "Email",
      password: "Password",
      submit: "Sign in",
    },
    admin: {
      dashboard: "Admin panel",
      cars: "Cars",
      owners: "Owners",
      reservations: "Reservations",
      settings: "Settings",
      addCar: "Add car",
      addOwner: "Add owner",
      noOwner: "No owner",
      assignOwner: "Assign owner",
      uploadImages: "Upload images",
      brandSection: "Brand & colors",
      smtpSection: "SMTP configuration",
      emailTemplatesSection: "Email templates",
      logoUpload: "Logo",
      uploadLogo: "Upload logo",
      removeLogo: "Remove logo",
      colors: "Color palette",
      contactSection: "Contact",
      testEmail: "Send test email",
    },
    owner: {
      dashboard: "Owner panel",
      myCars: "My cars",
      reservations: "Reservations",
      blockDates: "Block dates",
      addBlock: "Add block",
      blockReason: "Reason (optional)",
      noCars: "No cars assigned",
    },
  },
};
